import {Box, Grid} from '@mui/material';
import {layoutSelectors} from 'features/layout/redux';
import React from 'react';
import {useSelector} from 'react-redux';
import {enums} from 'types/enums';
import {IEdgeGatewayStatus} from 'types/StatesResponse';

export const EdgeGatewayStatusIcon = ({connectorId}: {connectorId: string}) => {
   const edgeGatewayStatus = useSelector(layoutSelectors.getEdgeGatewayStatuses);

   const status = edgeGatewayStatus?.find((s: IEdgeGatewayStatus) => s[connectorId]);
   const isConnected =
      status && status[connectorId].connectionStatus === enums.edgeGatewayStatus.enum.CONNECTED;

   return (
      <Grid
         container
         justifyContent="center"
         alignItems="center"
         spacing={0}
         width="100%"
         height="100%"
      >
         <Box
            width="1.5rem"
            height="1.5rem"
            borderRadius="50%"
            style={{backgroundColor: isConnected ? 'green' : 'red'}}
            component="div"
         />
      </Grid>
   );
};
